import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

export const DrawerLayer = styled.div`
  position: fixed;
  inset: 60px 0 0;
  z-index: ${tokens.zIndex.drawer};
`;

export const DrawerBackdrop = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.48);
  backdrop-filter: blur(2px);
`;

export const DrawerPanel = styled.aside`
  position: relative;
  width: min(320px, 86vw);
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.lg};
  padding:
    ${tokens.spacing.md}
    ${tokens.spacing.md}
    calc(${tokens.spacing.lg} + env(safe-area-inset-bottom));
  background: ${tokens.colors.blue[800]};
  color: ${tokens.colors.basics[0]};
  box-shadow: ${tokens.shadows.xl};
  overflow-y: auto;
  animation: mobile-drawer-enter ${tokens.transitions.duration.quick3} ease-out;

  @keyframes mobile-drawer-enter {
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(0);
    }
  }
`;

export const DrawerHeader = styled.div`
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${tokens.spacing.md};
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  font-size: ${tokens.typography.fontSize.lg};
  font-weight: ${tokens.typography.fontWeight.semibold};
`;

export const DrawerCloseButton = styled.button`
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  padding: 0;
  border: 0;
  border-radius: ${tokens.borderRadius.lg};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: inherit;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.basics[0]};
    outline-offset: 2px;
  }
`;

export const DrawerNavigation = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.sm};
`;

export const DrawerNavigationItem = styled.button<{
  $active: boolean;
  $unavailable: boolean;
}>`
  width: 100%;
  min-height: 52px;
  box-sizing: border-box;
  padding: ${tokens.spacing.sm} ${tokens.spacing.mmd};
  border: 1px solid
    ${({ $active }) =>
      $active ? tokens.colors.basics[0] : "transparent"};
  border-radius: ${tokens.borderRadius.lg};
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.mmd};
  background: ${({ $active }) =>
    $active ? tokens.colors.blue[500] : "transparent"};
  color: ${tokens.colors.basics[0]};
  font: inherit;
  font-size: ${tokens.typography.fontSize.md};
  font-weight: ${tokens.typography.fontWeight.medium};
  text-align: left;
  cursor: pointer;
  opacity: ${({ $unavailable }) => ($unavailable ? 0.55 : 1)};

  &:hover {
    background: ${({ $active }) =>
      $active ? tokens.colors.blue[500] : tokens.colors.blue[900]};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.basics[0]};
    outline-offset: 2px;
  }

  svg {
    flex: 0 0 auto;
  }
`;

export const DrawerNavigationItemDescription = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
